document.addEventListener('DOMContentLoaded', function() {
  
  // ==========================================
  // 1. GESTIONE AGGIORNAMENTO QUANTITÀ (ZERO REFRESH E FOCUS PRESERVATO)
  // ==========================================
  function updateCartItem(lineKey, quantity) {
    const row = document.querySelector(`.koji-cart-item-row[data-key="${lineKey}"]`);
    if (row) {
      row.classList.add('is-loading');
    }

    // Salva l'elemento attivo per rimettere il focus dopo l'aggiornamento DOM
    const activeEl = document.activeElement;
    let focusData = null;
    if (activeEl) {
        if (activeEl.classList.contains('koji-qty-plus')) focusData = { key: lineKey, type: 'plus' };
        else if (activeEl.classList.contains('koji-qty-minus')) focusData = { key: lineKey, type: 'minus' };
        else if (activeEl.classList.contains('koji-qty-input')) focusData = { key: lineKey, type: 'input' };
        else if (activeEl.classList.contains('koji-item-remove')) focusData = { key: lineKey, type: 'remove' };
    }

    const body = JSON.stringify({
      id: lineKey,
      quantity: quantity
    });

    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body
    })
    .then(response => response.json())
    .then(state => {
      const sectionElement = document.querySelector('.shopify-section');
      if (!sectionElement) return window.location.reload();
      
      const sectionId = sectionElement.id.replace('shopify-section-', '');
      
      fetch(`/?section_id=${sectionId}`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const newDoc = parser.parseFromString(html, 'text/html');
          
          const currentInner = document.querySelector('.koji-cart-page-inner');
          const newInner = newDoc.querySelector('.koji-cart-page-inner');
          
          if (currentInner && newInner) {
              currentInner.innerHTML = newInner.innerHTML;
              
              attachListeners(); 
              updateKojiCartReactions();

              // RIPRISTINO FOCUS PER ACCESSIBILITA' TASTIERA
              if (focusData) {
                  let selector = '';
                  if (focusData.type === 'plus') selector = `.koji-qty-plus[data-key="${focusData.key}"]`;
                  else if (focusData.type === 'minus') selector = `.koji-qty-minus[data-key="${focusData.key}"]`;
                  else if (focusData.type === 'input') selector = `.koji-qty-input[data-key="${focusData.key}"]`;
                  
                  if (selector) {
                      const elToFocus = document.querySelector(selector);
                      if (elToFocus) elToFocus.focus();
                  } else if (focusData.type === 'remove') {
                      // Se l'elemento è rimosso, sposta il focus in una zona logica per non perderlo
                      const summaryTitle = document.querySelector('.koji-summary-title');
                      if (summaryTitle) {
                          summaryTitle.setAttribute('tabindex', '-1');
                          summaryTitle.focus();
                      }
                  }
              }
          } else {
              window.location.reload();
          }
          
          window.dispatchEvent(new Event('cart:updated'));
        });

    })
    .catch(error => {
      console.error('Errore aggiornamento Carrello:', error);
      if (row) row.classList.remove('is-loading');
    });
  }

  function attachListeners() {
    // Gestione bottoni Più e Meno
    const qtyButtons = document.querySelectorAll('.koji-qty-btn');
    qtyButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const key = this.getAttribute('data-key');
        const input = document.querySelector(`.koji-qty-input[data-key="${key}"]`);
        
        if (!input) return;
        if(navigator.vibrate) navigator.vibrate(15);
        
        let currentValue = parseInt(input.value);
        if (this.classList.contains('koji-qty-plus')) {
          currentValue++;
        } else if (this.classList.contains('koji-qty-minus')) {
          currentValue = Math.max(0, currentValue - 1);
        }
        
        input.value = currentValue;
        updateCartItem(key, currentValue);
      });
    });

    // Gestione INPUT DIRETTO CON DEBOUNCE (Tempo Reale)
    let qtyDebounceTimer;
    const qtyInputs = document.querySelectorAll('.koji-qty-input');
    qtyInputs.forEach(input => {
      input.addEventListener('input', function() {
        clearTimeout(qtyDebounceTimer);
        const key = this.getAttribute('data-key');
        let value = parseInt(this.value);
        
        if(isNaN(value) || value < 0) return;
        
        qtyDebounceTimer = setTimeout(() => {
            updateCartItem(key, value);
        }, 500); 
      });
    });

    // Bottoni rimozione
    const removeLinks = document.querySelectorAll('.koji-item-remove');
    removeLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        if(navigator.vibrate) navigator.vibrate([20,30,20]);
        const key = this.getAttribute('data-key');
        updateCartItem(key, 0); 
      });
    });
  }

  // ==========================================
  // 3. KOJI REAZIONI DINAMICHE
  // ==========================================
  function updateKojiCartReactions() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cartData => {
         // Reaction Carrello Pieno
         const reactionEl = document.getElementById('koji-cart-reaction-text');
         if (reactionEl && cartData.item_count > 0) {
             const totalInCents = cartData.total_price;
             const itemCount = cartData.item_count;
             let text = "";
             
             if (totalInCents > 15000) { 
                 text = "Livello di potenza critico! Questo è un bottino leggendario. 👑🔥";
             } else if (itemCount >= 10) { 
                 text = "Hai svaligiato l'intero Covo? L'equipaggio è impressionato. 🎒💨";
             } else if (totalInCents >= 5000) { 
                 text = "Ottima selezione. La spedizione è già a carico nostro. 📦✨";
             } else {
                 text = "Hai un occhio infallibile. Procediamo verso la cassa? 🎯";
             }
             
             reactionEl.style.animation = 'none';
             reactionEl.offsetHeight; 
             reactionEl.style.animation = 'fadeIn 0.4s ease';
             reactionEl.textContent = text;
         }

         // Reaction Carrello Vuoto
         const emptyReactionEl = document.getElementById('koji-cart-empty-reaction');
         if(emptyReactionEl && cartData.item_count === 0) {
            const emptyTexts = [
              "Tutto tranquillo qui. Il tuo zaino è leggero... troppo leggero. 🎒💨",
              "Nessuna traccia di figure o manga in questo settore. 🕳️",
              "Non hai ancora trovato il One Piece, eh? 🏴‍☠️",
              "Zaino vuoto. C'è tanto spazio sulla tua libreria. 👁️"
            ];
            const randomEmpty = emptyTexts[Math.floor(Math.random() * emptyTexts.length)];
            emptyReactionEl.textContent = randomEmpty;
         }
      });
  }

  // Esecuzione Iniziale
  attachListeners();
  updateKojiCartReactions();
});